import Footer from '../Layouts/Footer';
import Header from '../Layouts/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from "react";
import ProgressBarComponent from '../Components/ProgressBarComponent';
import {  getAllowance, getPacks } from '../services/API';
import { associateCard, initRedeem } from '../Hashconnect';
import { requestImage } from '../services/HederaServices';
import { useSelector } from 'react-redux';

function Card() {
    const [loading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("Loading ...");
    const [isClaimSuccessFul, setIsClaimSuccessful] = useState(false);
    const [isAssociationSuccessFul, setIsAssociationSuccessful] = useState(false);
    const [isFindingPacks, setIsFindingPacks] = useState(false);
    const [packList, setPackList] = useState([]);
    const [oldPackList, setOldPackList] = useState([]);
    const [cards, setCards] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [revealing, setRevealing] = useState(false);
    const [revealed, setRevealed] = useState(false);
    const [revealingId, setRevealingId] = useState("");
    const [tokensPerPage, setTokensPerPage] = useState(50);
    const totalPages = Math.ceil(packList.length / tokensPerPage);
    const indexOfLastToken = currentPage * tokensPerPage;
    const indexOfFirstToken = indexOfLastToken - tokensPerPage;
    const currentTokens = packList.slice(indexOfFirstToken, indexOfLastToken);
    const tokenContainer = document.getElementById('token-container');
    const [currentToken, setCurrentToken] = useState({})
    const [currentTokenImages, setCurrentTokenImages] = useState([])
    const isAssociated = useSelector((state: any) => state.user.isCardAssociated)
  
  
    interface CardProps {
        cardFront: string;
        cardBack: string;
    }

    const Card: React.FC<CardProps> = ({ cardFront, cardBack }) => {
        const [isFlipped, setFlipped] = useState(false);

        const handleFlip = () => {
            setFlipped(!isFlipped);
        };

        return (
            <div className={`flip-card ${isFlipped ? "flipped" : ""}`} onClick={handleFlip}>
                <div className="flip-card-inner">
                    <div className="flip-card-front">
                        <img src={cardFront} alt="Card Front" />
                    </div>
                    <div className="flip-card-back">
                        <img src={cardBack} alt="Card Back" />
                    </div>
                </div>
            </div>
        );
    };


    const maxValue = 150;
    const speed = 12;
    let currValue = 0;
    let rafID: any = null;
    let inputRange: any;

    const unlockStartHandler = (e: any) => {
        window.cancelAnimationFrame(rafID);
        currValue = +e.target.value;
    };

    const getTokenAllowance = async (token: any) => {
        setLoading(true)
       const transaction = await getAllowance(token);
       if(transaction == true){     
        setTimeout(async() => {
            setLoading(true)
            await getAllPacks(); 
            setLoading(false)  
        }, 2000);
         
       }
       setLoading(false)
    }
    const unlockEndHandler = async (e: any) => {
        currValue = +e.target.value;
        if (currValue >= maxValue) {

            setLoading(true)
            setRevealing(false)
            const tx: any = await initRedeem(currentToken)
            // console.log(tx)
            if (tx.tokensData) {
                const tokenImages = tx.tokensData
                setCurrentTokenImages(tokenImages)
                successHandler();
                await getAllPacks()
            } else {
                closeClaimPackContainer()
            }

            setLoading(false)

        } else {
            rafID = window.requestAnimationFrame(animateHandler);
        }
    };

    const animateHandler = () => {
        inputRange.value = currValue;
        if (currValue > -1) {
            window.requestAnimationFrame(animateHandler);
        }
        currValue = currValue - speed;
    };

    const successHandler = () => {
        setRevealed(true)
        setRevealing(true)

    };


    const handleTokensPerPage = (amount: number) => {
        setTokensPerPage(amount);
    };


    const handleSerialSearch = (serial: any) => {
        if (serial) {
            const newList = oldPackList.filter((token: any) => token.serial_number.toString().includes(serial))
            setPackList(newList)
        }
    };

    const handlePageChange = (newPage: any) => {
        setCurrentPage(newPage);
    };

    const handleTierChange = (tier: any) => {
        if (tier == 0) {
            setPackList(oldPackList)
        } else {
            const newList = oldPackList.filter((token: any) => token.token_id == tier)
            setPackList(newList)
        }
    };


    async function closeSuccessModal() {
        setIsAssociationSuccessful(false)
        setIsClaimSuccessful(false)
    }
    useEffect(() => {
        const interval = setInterval(async() => {
        const newData = localStorage.getItem('accessToken');
      if (newData) {
      
        getAllPacks();
        clearInterval(interval);
      

      }else{
        setPackList([])
        setOldPackList([]);
      }
 
    }, 1000);
    return () => clearInterval(interval);
      }, []);



    async function getAllPacks() {
        try {
            let token: string | null = localStorage.getItem("accessToken");
            if (token) {
                // setLoadingMessage("Loading Packs...")
			    // setLoading(true)
                const packs = await getPacks(token);
                setPackList(packs)
                setOldPackList(packs);
                setLoadingMessage("Loading...")
			    // setLoading(false)
     
         
            }
        } catch (error) {

        }
    }

    const closeClaimPackContainer = async() => {
        setRevealing(false)
        setRevealed(false)
        tokenContainer?.classList.remove('hide');
        await getAllPacks()
    }

    const associate = async() => {
        const tx = await associateCard()
        if(tx == true){
          window.location.reload()
           
        }
 
    }

    const handleLevelChange = (amount: number) => {
        // console.log(amount)
    }

    const openClaimPackContainer = (token: any) => {
        // inputRange.value = 0;
        setRevealing(true)
        tokenContainer?.classList.add('hide');
        setCurrentToken(token)
        // console.log(token)
        switch (token.token_id) {
            case "0.0.4334673":
            case "0.0.827749":
                setRevealingId("common")
                break;
            case "0.0.4334674":
            case "0.0.817606":
                setRevealingId("unCommon")
                break;
            case "0.0.4334685":
            case "0.0.801906":
                setRevealingId("rare")
                break;
            case "0.0.4334687":
            case "0.0.788370":
                setRevealingId("epic")
                break;
            case "0.0.4334689":
            case "0.0.774295":
                setRevealingId("legendary")
                break;
            default:
                break;
        }

    }

    const renderPaginationButtons = () => {
        const maxButtons = 6;
        const middleButton = Math.ceil(maxButtons / 2);

        if (totalPages <= maxButtons) {
            return Array.from({ length: totalPages }, (_, index) => (
                <button key={index + 1} onClick={() => handlePageChange(index + 1)}>
                    {index + 1}
                </button>
            ));
        } else {
            let startPage = Math.max(1, currentPage - middleButton + 1);
            let endPage = Math.min(totalPages, startPage + maxButtons - 1);

            if (endPage - startPage < maxButtons - 1) {
                startPage = Math.max(1, endPage - maxButtons + 1);
            }

            return Array.from({ length: endPage - startPage + 1 }, (_, index) => (
                <button key={startPage + index} onClick={() => handlePageChange(startPage + index)}>
                    {startPage + index}
                </button>
            ));
        }
    };


    return (
        <>
            <Header></Header>
            {/* <div className="mainDiv"> */}
                      <div id='token-container' className="token-container">
                      <div className='filterstext'><span>Seeing {currentTokens.length} / {oldPackList.length} tokens</span></div>
                      <div className='filters'>
                        {(!isAssociated && currentTokens.length > 0) ?
                            <button id="btnConnect" className="btnAssociate" onClick={()=> associate()}>Associate</button>
                        :
                        <></>

                        }
                          <input className="filterbtn noborder" placeholder='Serial number' onChange={(e) => handleSerialSearch(e.target.value)} />
                          <select className="filterbtn" onChange={(e) => handleTierChange(e.target.value)}>
                              <option value={0}>Tier</option>
                              <option value='0.0.4334673'>Tier 1</option>
                              <option value='0.0.4334674'>Tier 2</option>
                              <option value='0.0.4334685'>Tier 3</option>
                              <option value='0.0.4334687'>Tier 4</option>
                              <option value='0.0.4334689'>Tier 5</option>
                          </select>

                          <select className="filterbtn" onChange={(e) => handleTokensPerPage(parseInt(e.target.value))}>
                              <option value={0}>Per Page</option>
                              <option value={15}>15</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                              <option value={oldPackList.length}>All</option>
      
                          </select>
                      </div>
            {(currentTokens.length > 0) ?
            <>
                      <div className='token-row'>
                          {currentTokens.map((token: any) => (
                              <div className="token-item" key={token.serial_number + '-' + token.token_id}>
                                  <img className='packImg' src={'/tiers/' + token.token_id + '.png'} width='90px'></img>
                                  <span className="packTitle"># {token.serial_number}</span>
                                  {(!isAssociated) ?
                                  <></>
                                  :
                                  
                                  (isAssociated && token.spender == "0.0.3821765") ?
                                  <div className="revealBtn" style={{backgroundColor:"#4caf50"}} onClick={() => openClaimPackContainer(token)} > Reveal</div>
                                  :
                                   <div className="revealBtn" onClick={() => getTokenAllowance(token) }> Approve</div>
                               }
                  </div>
                  ))
      
                          }
      
      
              </div >
      
                  <div className="pagination">
                      {renderPaginationButtons()}
                  </div>
         </>             
                      :
                      <>
                      <center>
                        <div className='no-tokens'>

                      <img className='mt-150' src='/css/img-old/character_01.png'></img>
                      <h1>No packs found.</h1>
                        </div>
                      </center>
                      </>
                  }
                  </div >
      



        <Footer></Footer>
    {
        revealing ?
            <div id="claimPackContainer" className="claimPackContainer">
                <div id="closeClaimPackContainer" className="closeClaimPackContainer" onClick={() => closeClaimPackContainer()}>
                    <span className="material-symbols-outlined">close</span>
                </div>
                {revealed ?
                    <div id="cardsContainer" className="cardsContainer">

                        {currentTokenImages.map((image: any) => (
                            <>
                                <Card key={image}  cardFront="/css/img/backCard_01.jpg" cardBack={image} />
                            </>
                        ))}
                        {/* <Card cardFront="/css/img/blankCard.jpg" cardBack="/css/img/rantCPU_card_2.png" />
                            <Card cardFront="/css/img/blankCard.jpg" cardBack="/css/img/rantCPU_card_3.png" />
                            <Card cardFront="/css/img/blankCard.jpg" cardBack="/css/img/rantCPU_card_4.png" />
                            <Card cardFront="/css/img/blankCard.jpg" cardBack="/css/img/rantCPU_card_1.png" />
                            <Card cardFront="/css/img/blankCard.jpg" cardBack="/css/img/rantCPU_card_2.png" />
                            <Card cardFront="/css/img/blankCard.jpg" cardBack="/css/img/rantCPU_card_3.png" />
                            <Card cardFront="/css/img/blankCard.jpg" cardBack="/css/img/rantCPU_card_4.png" /> */}



                        {/* 
                            <div className="card"><img src='/css/img/rantCPU_card_2.png' height="350px"></img></div>
                            <div className="card"><img src='/css/img/rantCPU_card_3.png' height="350px"></img></div>
                            <div className="card"><img src='/css/img/rantCPU_card_4.png' height="350px"></img></div>
                            <div className="card"><img src='/css/img/rantCPU_card_1.png' height="350px"></img></div>
                            <div className="card"><img src='/css/img/rantCPU_card_2.png' height="350px"></img></div>
                            <div className="card"><img src='/css/img/rantCPU_card_3.png' height="350px"></img></div>
                            <div className="card"><img src='/css/img/rantCPU_card_4.png' height="350px"></img></div>
                            <div className="card"><img src='/css/img/rantCPU_card_3.png' height="350px"></img></div>
                            <div className="card"><img src='/css/img/rantCPU_card_4.png' height="350px"></img></div>
                            */}

                    </div>
                    :
                    <div id="claimRewardContainer" className={'claimRewardContainer dashed ' + revealingId}>
                        <input
                            type="range"
                            defaultValue={0}
                            min={0}
                            max={maxValue}
                            className='pullee'
                            ref={(el) => {
                                inputRange = el;
                            }}
                            onMouseDown={(e: any) => unlockStartHandler(e)}
                            onMouseUp={(e: any) => unlockEndHandler(e)}
                            onTouchEnd={(e: any) => unlockEndHandler(e)}
                        />
                    </div>
                }

            </div>
            :
            <></>
    }

    {
        (loading === true) ?
        <ProgressBarComponent loadingMessage={loadingMessage} />
        :
        <></>
    }
        </>
    );
}

export default Card;